<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  title: {
    type: String,
    default: '',
  },
  items: {
    type: Array,
    default: () => [],
  },
  collapsed: {
    type: Boolean,
    default: false,
  },
  hideAddAll: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['add', 'close', 'expand']);

const { t } = useI18n();

const onAddClick = () => {
  emit('add');
};

const onClickClose = () => {
  emit('close');
};

const onClickExpand = () => {
  emit('expand');
};
</script>

<template>
  <div
    class="flex flex-col items-start self-stretch rounded-xl w-full overflow-hidden border-2 border-dashed border-n-brand/30 bg-n-brand/5"
  >
    <!-- 标题栏 -->
    <div class="flex items-center justify-between w-full gap-3 px-4 pb-1 pt-4">
      <div class="flex items-center gap-3">
        <h5 class="text-sm font-medium text-n-slate-11">{{ title }}</h5>
        <span
          class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-n-brand/10 text-n-brand"
        >
          推荐
        </span>
        <template v-if="!collapsed && !hideAddAll">
          <span class="h-3 w-px bg-n-weak" />
          <Button
            :label="t('PILOT.ASSISTANTS.GUARDRAILS.ADD.SUGGESTED.ADD')"
            ghost
            xs
            slate
            class="!text-sm !text-n-slate-11 flex-shrink-0"
            @click="onAddClick"
          />
        </template>
      </div>
      <Button
        ghost
        xs
        slate
        :icon="collapsed ? 'i-lucide-chevron-down' : 'i-lucide-x'"
        class="!text-sm !text-n-slate-11 flex-shrink-0"
        @click="collapsed ? onClickExpand() : onClickClose()"
      />
    </div>
    <!-- 规则列表 -->
    <div
      v-if="!collapsed"
      class="flex flex-col items-start w-full max-h-80 overflow-y-auto"
    >
      <div
        v-for="item in items"
        :key="item.id || item.key || item.content"
        class="w-full px-4 py-3 bg-white/60 flex items-center gap-2"
      >
        <span class="i-lucide-lightbulb size-4 text-n-brand flex-shrink-0" />
        <div class="flex-1 min-w-0">
          <slot :item="item" />
        </div>
      </div>
    </div>
  </div>
</template>
